import React from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import { INTERSTITIAL_SELECT_PROFILE } from '../../../services/interstitial/index'
import { TYPE_MY_ACCOUNT_CHILD_PROFILE_CHANGE_PLAN } from '../../../services/dialog/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import Button, { TYPES } from '../../Button/index'
import { H4 } from '../../Heading/index'

function MyAccountChildProfileChangePlanModal (props) {
  const { staticText, setInterstitial, removeModal } = props

  return (
    <div className="my-account-child-profile-change-plan-modal">
      <H4 className="my-account-child-profile-change-plan-modal__title">
        {staticText.getIn(['data', 'title'])}
      </H4>
      <p className="my-account-child-profile-change-plan-modal__description">
        {staticText.getIn(['data', 'description'])}
      </p>
      <Button
        className="my-account-child-profile-change-plan-modal__cta"
        type={TYPES.PRIMARY}
        onClick={() => {
          removeModal(TYPE_MY_ACCOUNT_CHILD_PROFILE_CHANGE_PLAN)
          setInterstitial(
            INTERSTITIAL_SELECT_PROFILE,
          )
        }}
      >
        {staticText.getIn(['data', 'cta'])}
      </Button>
    </div>
  )
}

export default compose(
  connectStaticText({ storeKey: 'myAccountChildProfileChangePlanModal' }),
  connectRedux(
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setInterstitial: actions.interstitial.setInterstitial,
        removeModal: actions.dialog.removeModal,
      }
    },
  ),
)(MyAccountChildProfileChangePlanModal)
